export default "__VITE_ASSET__Ez4uGDQi__"